import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '../ui/dialog';
import { useApi, watchSiteChanges } from '../../lib/api';

export const PasswordHelp = ({ text }) => {
  const query = new URLSearchParams(window.location.search);
  query.set('forgot', '1');
  return <div className="login-forgot-row"><Link data-testid="login-forgot-password" className="login-text-link" to={`/login?${query}`}>{text.forgotPassword}</Link></div>;
};

export const LoginLegal = ({ text }) => {
  const { data: pages, reload, loading, error } = useApi('/public/pages');
  const [unavailable, setUnavailable] = useState(null);
  useEffect(() => watchSiteChanges(reload), [reload]);
  const terms = pages?.find(p => /^(terms|terms-of-service|terms-and-conditions)$/.test(p.slug));
  const privacy = pages?.find(p => /^(privacy|privacy-policy)$/.test(p.slug));
  const policyLink = (page, key, label) => !loading && !error && page
    ? <Link data-testid={`login-${key}-link`} className="login-text-link" to={`/pages/${page.slug}`}>{label}</Link>
    : <button data-testid={`login-${key}-link`} type="button" className="login-text-link" disabled={loading} aria-busy={loading} onClick={() => setUnavailable(label)}>{label}</button>;
  return <>
    <p className="login-legal" data-testid="login-legal">
      {terms && privacy && <>{text.agreement} </>}
      {policyLink(terms, 'terms', text.terms)}<span> {terms && privacy ? text.and : '·'} </span>{policyLink(privacy, 'privacy', text.privacy)}
    </p>
    <Dialog open={Boolean(unavailable)} onOpenChange={open => { if (!open) setUnavailable(null); }}>
      <DialogContent data-testid="login-policy-dialog" className="login-help-dialog">
        <DialogHeader><DialogTitle data-testid="login-policy-title">{unavailable}</DialogTitle>
          <DialogDescription data-testid="login-policy-status">{error ? text.policyLoadError : text.policyUnavailable}</DialogDescription></DialogHeader>
        {error && <button type="button" data-testid="login-policy-retry" className="login-text-link" disabled={loading} onClick={() => { reload(); setUnavailable(null); }}>{text.retry}</button>}
      </DialogContent>
    </Dialog>
  </>;
};